import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './errors/page-not-found/page-not-found.component';
import { FiveHundredErrorComponent } from './errors/five-hundred-error/five-hundred-error.component';

import { AuthGuard } from './guards/auth.guard';
import { NotAuthGuard } from './guards/not-auth.guard';
import { ContactFormComponent } from './dashboard/components/contact-form/contact-form.component';
import { ContactUsComponent } from './dashboard/components/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './dashboard/components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './dashboard/components/terms-and-conditions/terms-and-conditions.component';
import { MarketingPageComponent } from './shared/components/marketing-page/marketing-page.component';
import { MaintenencePageComponent } from './dashboard/components/maintenence-page/maintenence-page.component';
import { MaintenanceGuard } from './guards/maintenance.guard';
import { IgnoreMaintenancePageComponent } from './dashboard/components/ignore-maintenance-page/ignore-maintenance-page.component';
import { AcceptMarketingConsentComponent } from './unauthenticated/accept-markting-consent/accept-marketing-consent.component';

const routes: Routes = [
  {
    path: 'error',
    component: FiveHundredErrorComponent,
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: 'maintenance',
    component: MaintenencePageComponent,
  },
  {
    path: 'marketing-consent/:userUUID',
    component: AcceptMarketingConsentComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'maintenance-ignore',
    component: IgnoreMaintenancePageComponent,
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'contact-us/form',
    component: ContactFormComponent,
    canActivate: [MaintenanceGuard],
  },

  {
    path: 'privacy-notice',
    component: PrivacyPolicyComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [MaintenanceGuard, AuthGuard],
  },
  {
    path: 'webviews',
    loadChildren: () =>
      import('./webviews/webviews.module').then((m) => m.WebviewsModule),
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'promo/:promoUID',
    component: MarketingPageComponent,
    data: {
      isMarketingPage: true,
    },
    canActivate: [MaintenanceGuard, NotAuthGuard],
  },
  {
    path: '',
    canActivate: [MaintenanceGuard, NotAuthGuard],
    loadChildren: () =>
      import('./login-register/login-register.module').then(
        (m) => m.LoginRegisterModule
      ),
  },
  {
    path: 'eis',
    loadChildren: () =>
      import('./reporting-system/reporting-system.module').then(
        (module) => module.ReportingSystemModule
      ),
    canActivate: [MaintenanceGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledNonBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
